// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SideBarItemGroup-base__WkwHd{display:flex;flex-direction:column}.SideBarItemGroup-items__fnHdQ{display:flex;flex-direction:column;overflow:hidden;transition:var(--duration-normal);transition-property:max-height}.SideBarItemGroup-items__fnHdQ *{pointer-events:none}.SideBarItemGroup-open__xdN_D{gap:var(--size-0_5)}.SideBarItemGroup-open__xdN_D .SideBarItemGroup-items__fnHdQ *{pointer-events:all}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "SideBarItemGroup-base__WkwHd",
	"items": "SideBarItemGroup-items__fnHdQ",
	"open": "SideBarItemGroup-open__xdN_D"
};
export default ___CSS_LOADER_EXPORT___;
